import { memo } from 'react';
import { DataTableSkeleton } from '../components/DataTable';
import { TRANSACTIONS_COLUMNS, TRANSACTIONS_TABLE_MIN_WIDTH } from './TransactionsTable';

export const TransactionsTableSkeleton = memo(function TransactionsTableSkeleton() {
  return <DataTableSkeleton columns={TRANSACTIONS_COLUMNS} rows={5} minWidth={TRANSACTIONS_TABLE_MIN_WIDTH} />;
});

export default TransactionsTableSkeleton;
